<template>
<div class="testimonials">
  <div class="testimonials__button">
    <a href="#"
      @click.prevent="openForm()"
      title="Bewertung abgeben"
      class="btn btn-primary"><span class="fas fa-pen"></span>Bewertung abgeben</a>
  </div>

  <div v-if="visible" class="contact__wrapper testimonials-form has-background has-bgbright-background-color">
  <v-app class="ast-container">
    <contact-form :name="name" buttonText="Bewertung abgeben" :requiredFields="requiredFields">
      <h3 class="text-center">Kundenstimme abgeben</h3>

      <testimonial-form></testimonial-form>
      <template slot="disclaimer">
        Mit der Erfassung, Speicherung, Verwendung und Veröffentlichung meiner Bewertung bin ich einverstanden.
        Hinweis: Sie können Ihre Einwilligung jederzeit widerrufen.
      </template>
    </contact-form>
  </v-app>
  </div>
</div>
</template>

<script>
import ContactForm from "./ContactForm.vue";
import TestimonialForm from "./TestimonialForm.vue";

export default {
  name: "TestimonialApp",

  components: {
    ContactForm,
    TestimonialForm
  },

  data() {
    return {
      name: "testimonials",
      visible: false
    }
  },

  computed: {
    requiredFields() {
      return this.$yeti.formRequiredFields(this.name);
    }
  },

  methods: {
    openForm() {
      this.visible = !this.visible;

      this.$nextTick(() => {
        let element = this.$el;
        let offsetTop = element.offsetTop - 100;

        window.scrollTo({top: offsetTop, behavior: 'smooth'});
      });
    }
  }
};
</script>
